import { CADASTRAR_CONFIGURACAO_ENCOMENDA, BUSCAR_CONFIGURACAO_ENCOMENDA } from '../../actions/types'

const initialState = undefined
const estadoInicial = {
  id: null,
  habilitadoPrecoKg: false,
  precoKg: null,
  habilitadoPrecoFixoMaisValorKg: false,
  valorKg: null,
  precoFixo: null,
  habilitadoTaxaSeguro: false,
  taxaSeguro: null,
  mensagem: null,
  tiposCalculoEncomenda: [],
  habilitadoPrecoMetroCubico: false,
  precoMetroCubico: null,

}

export default function reducerConfiguracaoEncomenda(state = estadoInicial, action = initialState) {
  switch (action.type) {
    case CADASTRAR_CONFIGURACAO_ENCOMENDA: {
      return action.payload.data
    }

    case BUSCAR_CONFIGURACAO_ENCOMENDA: {
      if (action.payload.data) {
        return action.payload.data
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
